"use client";

import { motion } from "framer-motion";
import { useState } from "react";

const NilaiLogoCard = ({ index, image, title, description }) => {
  const [isActive, setIsActive] = useState(false);

  const motionConfig = {
    1: { initial: { opacity: 0, x: -100 }, whileInView: { opacity: 1, x: 0 } },
    2: { initial: { opacity: 0, y: 100 }, whileInView: { opacity: 1, y: 0 } },
    3: { initial: { opacity: 0, x: 100 }, whileInView: { opacity: 1, x: 0 } },
  };

  const toggleActive = () => {
    console.log("active", isActive);
    setIsActive(!isActive);
  };

  return (
    <motion.div
      initial={motionConfig[index]?.initial || { opacity: 0, x: 0, y: 0 }}
      whileInView={
        motionConfig[index]?.whileInView || { opacity: 1, x: 0, y: 0 }
      }
      transition={{
        duration: 1,
        ease: "easeInOut",
        type: "spring",
        stiffness: 100,
        damping: 30,
        delay: 0.5,
      }}
      viewport={{ once: true }}
      className={`group rounded-xl ${
        isActive ? "shadow-lg" : "shadow-md"
      }  transition-shadow duration-300 h-[481px] flex flex-col justify-end overflow-hidden relative`}
      onClick={() => toggleActive()}
    >
      {/* Background Wrapper */}
      <div
        className={`absolute ${
          isActive ? "scale-120" : ""
        } inset-0 transition-all ease-in-out duration-2000 group-hover:scale-120 `}
        style={{
          backgroundImage: `url('${image}')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>

      {/* Content */}
      <div
        className={`text-center relative z-10 flex flex-col justify-end px-8 py-10 h-full rounded-lg bg-gradient-to-t from-black from-0% to-transparent to-60% transition-all duration-700 ease-in-out
        ${isActive ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} 
        group-hover:opacity-100 group-hover:translate-y-0`}
      >
        <h4 className="text-white font-semibold text-4xl sm:text-5xl md:text-3xl lg:text-4xl xl:text-5xl 2xl:text-6xl mb-2">
          {title}
        </h4>
        <p className="text-base md:text-xl text-gray-200">{description}</p>
      </div>
    </motion.div>
  );
};

export default NilaiLogoCard;
